import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { handleListResponse, seo } from "utils/utils";
import {
  getAppointmentDetail,
  addAppointment,
} from "../../reduxStore/action/appointmentActions";
import {
  getSiteVisitStatusData,
  updateSiteVisitStatus,
} from "../../reduxStore/action/siteVisitActions";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse, isEmpty } from "../../utils/utils";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";

const Revisit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const [appointmentData, setAppointmentData] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const [siteVisitMapping, setSiteVisitMapping] = useState(null);
  const { response: res } = useSelector((state) => state.login);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const { appointment_id = "" } = params || {};

  // useEffect(() => {
  //   if (leadId) {
  //     setForm({ ...form, lead_id: leadId, property_id: propertyId });
  //   }
  // }, [leadId, propertyId]);

  // const getVisitorListSelector = useSelector(
  //   (state) => state.appointment?.response?.data
  // );

  // const propertySelector = useSelector((state) => state.propertyData);

  const addAppointmentSelector = useSelector((state) => state.appointment);

  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      pickup_location: e,
      pickup_latitude: "",
      pickup_longitude: "",
    };
    setForm(nextFormState);
  };

  const onSelect = (latLng, pickup_location) => {
    const nextFormState = {
      ...form,
      pickup_location: pickup_location,
      pickup_latitude: latLng.lat,
      pickup_longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (appointment_time) => {
    let formErr = { ...formVaild };
    if (appointment_time) {
      const nextFormState = {
        ...form,
        appointment_time: moment("2000-01-01 " + appointment_time).format(
          "hh:mm A"
        ),
      };
      setForm(nextFormState);

      if (!isEmpty(formErr?.appointment_time)) {
        delete formErr.appointment_time;
      }
    } else {
      formErr["appointment_time"] = strings.validTime;
    }
    setFormVaild(formErr);
  };

  useEffect(() => {
    dispatch(getAppointmentDetail({ appointment_id }));
  }, [appointment_id, dispatch]);

  useEffect(() => {
    if (addAppointmentSelector.response) {
      const { response } = addAppointmentSelector;
      if (response?.status === 200) {
        setAppointmentData(handleDetailResponse(response?.data));
      } else {
        setAppointmentData({});
      }
    }
  }, [addAppointmentSelector]);

  // Fetch site visit mapping for LMS integration
  useEffect(() => {
    if (appointment_id) {
      dispatch(getSiteVisitStatusData({ appointment_id }))
        .then((res) => {
          if (res?.data?.length > 0) {
            setSiteVisitMapping(res.data[0]);
          }
        })
        .catch((err) => {
          console.error("Error fetching site visit mapping:", err);
        });
    }
  }, [appointment_id, dispatch]);

  useEffect(() => {
    if (addAppointmentSelector.create === true) {
      if (addAppointmentSelector?.addResponse?.status === 200) {
        // Send closing status update to LMS if mapping exists
        if (siteVisitMapping?.jv_site_visit_id) {
          const payload = {
            jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
            status: "Not Visited", // Reset status for new revisit appointment
            closingStatus: "Revisit",
            role: res?.data?.role_title || "auto",
          };

          console.log("📤 [Frontend] Sending closing status update (Revisit)");
          console.log(
            "📤 [Frontend] Payload:",
            JSON.stringify(payload, null, 2)
          );

          dispatch(updateSiteVisitStatus(payload))
            .then((res) => {
              if (res) {
                console.log("LMS notified about revisit status");
              }
            })
            .catch((err) => {
              console.error("❌ [Frontend] Error updating LMS:", err);
            })
            .finally(() => {
              setForm({});
              navigatpage("/appointment");
            });
        } else {
          setForm({});
          navigatpage("/appointment");
        }
      }
    }
  }, [addAppointmentSelector]);

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      formData.append("lead_id", appointmentData.lead_id);
      formData.append("property_id", appointmentData.property_id);
      form.appointment_date &&
        formData.append("appointment_date", form.appointment_date);
      form.appointment_time &&
        formData.append("appointment_time", form.appointment_time);
      formData.append("pickup", appointmentData.pickup);
      formData.append("pickup_location", appointmentData.pickup_location);
      formData.append("pickup_address", appointmentData.pickup_address);
      formData.append("pickup_longitude", appointmentData.pickup_longitude);
      formData.append("pickup_latitude", appointmentData.pickup_latitude);
      // formData.append("number_of_guest", appointmentData.number_of_guest);
      formData.append("type", 1);
      formData.append("update_type", 1);
      dispatch(addAppointment(formData));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    // if (!form.lead_id) {
    //   formError = true;
    //   err["lead_id"] = strings.leadErr;
    // }
    // if (!form.property_id) {
    //   formError = true;
    //   err["property_id"] = strings.propertynameErr;
    // }
    if (!form.appointment_date) {
      formError = true;
      err["appointment_date"] = strings.followup_dateErr;
    }
    if (!form.appointment_time) {
      formError = true;
      err["appointment_time"] = strings.followup_timeErr;
    }
    // if (form.pickup === "Yes") {
    //   if (!form.pickup_location) {
    //     formError = true;
    //     err["pickup_location"] = strings.pickupLocationErr;
    //   }
    //   if (!form.pickup_address) {
    //     formError = true;
    //     err["pickup_address"] = strings.addressErr;
    //   }
    //   if (!form.number_of_guest) {
    //     formError = true;
    //     err["number_of_guest"] = strings.numberOfGuest;
    //   } else if (isNaN(form.number_of_guest)) {
    //     formError = true;
    //     err["number_of_guest"] = strings.validNumber;
    //   }
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Add Appointment",
      metaDescription: "Add appointment details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.revisit}
        url={"/appointment"}
        parentListing={strings.appointmentList}
        titleactive={strings.revisit}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addAppointment}</h5>
              </div>
              <div className="card-body">
                {/* <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectLead}
                        <span className="required-field"></span>
                      </label>
                      <select
                        className="form-control"
                        id="exampleFormControlSelect9"
                        name="lead_id"
                        disabled={leadId ? true : false}
                        value={form.lead_id}
                        onChange={(e) => {
                          let property_id = handleDetailResponse(
                            getVisitorListSelector?.filter(
                              (i) => i.lead_id === e.target.value
                            )
                          )?.property_id;
                          const nextFormState = {
                            ...form,
                            lead_id: e.target.value,
                            property_id: property_id ? property_id : "",
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectlead}
                        </option>
                        {getVisitorListSelector?.map((item, index) => (
                          <option key={index} value={item._id}>
                            {`${item.first_name || ""} ${item.last_name || ""}`.trim()}
                          </option>
                        ))}
                      </select>
                      {formVaild?.lead_id && (
                        <span style={{ color: "red" }}>
                          {formVaild?.lead_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.selectProperty}
                        <span className="required-field"></span>
                      </label>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="property_id"
                        value={form.property_id}
                        onChange={(e) => {
                          var index = e.nativeEvent.target.selectedIndex;
                          var property_title = e.nativeEvent.target[index].text;
                          const nextFormState = {
                            ...form,
                            property_id: e.target.value,
                            property_title: property_title,
                          };
                          setForm(nextFormState);
                        }}
                      >
                        <option value="">
                          {strings.selectProp}
                        </option>
                        {apiResponse &&
                          apiResponse.map((item, index) => (
                            <option key={index} value={item.property_id}>
                              {item.property_title}
                            </option>
                          ))}
                      </select>
                      {formVaild?.property_id && (
                        <span style={{ color: "red" }}>
                          {formVaild?.property_id}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}
                <div className="row ">
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentDate}
                        <span className="required-field"></span>
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        name="appointment_date"
                        type="Date"
                        value={form?.appointment_date}
                        onChange={handleInputField}
                        min={moment().format("yyyy-MM-DD")}
                        max={moment().add(30, "days").format("yyyy-MM-DD")}
                      />
                      {formVaild?.appointment_date && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_date}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentTime}
                        <i
                          className="fa fa-info-circle pl-1 pr-1"
                          title={strings.AppointmentTimeDetail}
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                        ></i>
                        <span className="required-field"></span>
                      </label>

                      <TimePicker
                        onChange={handleInputTime}
                        value={form?.appointment_time}
                        clockIcon={null}
                        clearIcon={null}
                        disableClock={true}
                        format={"hh:mm a"}
                        className="form-control"
                        name="appointment_time"
                      />
                      {formVaild?.appointment_time && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_time}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlLastName">
                        {strings.pickup}
                      </label>
                      <div className="col">
                        <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                          <div className="radio radio-primary mr-5">
                            <input
                              id="radioinline4"
                              type="radio"
                              name="pickup"
                              value={"Yes"}
                              checked={form.pickup === "Yes" ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline4">
                              {strings.yes}
                            </label>
                          </div>
                          <div className="radio radio-primary mr-5 ml-5">
                            <input
                              id="radioinline5"
                              type="radio"
                              name="pickup"
                              value={"No"}
                              checked={form.pickup === "No" ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline5">
                              {strings.no}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* {form.pickup === "Yes" ? (
                  <>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.pickuplocation}
                            <span className="required-field"></span>
                          </label>
                          <AutocompletePlace
                            placeholder={strings.pickuplocation}
                            value={form.pickup_location}
                            onChange={handleInputArea}
                            onSelect={onSelect}
                            name="pickup_location"
                          />
                          {formVaild?.pickup_location && (
                            <span style={{ color: "red" }}>
                              {formVaild?.pickup_location}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.address}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            autoComplete="off"
                            type="text"
                            name="pickup_address"
                            value={form.pickup_address}
                            onChange={handleInputField}
                            placeholder={strings.address}
                          />
                          {formVaild?.pickup_address && (
                            <span style={{ color: "red" }}>
                              {formVaild?.pickup_address}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.numberofGuest}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            autoComplete="off"
                            type="number"
                            name="number_of_guest"
                            value={form.number_of_guest}
                            onChange={handleInputField}
                            placeholder={strings.numberofGuest}
                            onKeyPress={(e) => {
                              if (e.target.value.length >= 2) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formVaild?.number_of_guest && (
                            <span style={{ color: "red" }}>
                              {formVaild?.number_of_guest}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null} */}
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Revisit;
